import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { Picker, Modal, Input } from 'antd-mobile'
import MediaViewer from '../MediaViewer';
import GraphemeSplitter from 'grapheme-splitter';
import { Avatar, Button, Spinner, ButtonGroup, IconButton, Link, Snackbar, FormStatus } from '@vkontakte/vkui';
import {
    Icon20TextBoldOutline,
    Icon20TextItalicOutline,
    Icon20TextUnderlineOutline,
    Icon20TextStrikethroughOutline,
    Icon20Chain,
    Icon20PicturePlusOutline,
    Icon20DeleteOutline,
    Icon20SquareSplit4Outline,
    Icon20CheckAlt,
    Icon24ExternalLinkOutline,
    Icon24Send,
    Icon24Clock,
    Icon16Notebook,
    Icon16CancelCircle,
    Icon28PlayCircleFillGray
} from '@vkontakte/icons';
import DOMPurify from 'dompurify';
import '../Post.css';

const tg = window.Telegram.WebApp;

const PostPage = ({ isMobile, selectedPremodePost, selectedGroup, activeView, setActiveView, activePanel, setActivePanel, showAlert, avatarSrc, premodePosts, setPremodePosts }) => {
    const [media, setMedia] = useState(selectedPremodePost.media || []);
    const [postOriginal, setPostOriginal] = useState(selectedPremodePost.post_original);
    const [editMedia, setEditMedia] = useState(false);
    const [url, setUrl] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [savedSelection, setSavedSelection] = useState(null);
    const [draggingIndex, setDraggingIndex] = useState(null);
    const [text, setText] = useState(selectedPremodePost.text);
    const [loadingScreen, setLoadingScreen] = useState('none');
    const [loadingText, setLoadingText] = useState('');
    const [charCount, setCharCount] = useState(0);
    const [snackbar, setSnackbar] = useState(null);
    const textRef = useRef(null);
    const mediaInputRef = useRef(null);
    const rangeRef = useRef(null);
    const inputRef = useRef(null);

    const [isBold, setIsBold] = useState(false);
    const [isItalic, setIsItalic] = useState(false);
    const [isUnderline, setIsUnderline] = useState(false);
    const [isStrikeThrough, setIsStrikeThrough] = useState(false);
    const [isLink, setIsLink] = useState(false);

    // ИСПРАВЛЕНИЕ: Правильно вычисляем превышен лимит или нет
    const maxCharCount = media.length >= 1 ? 1024 : 4096;
    const isExceeded = charCount > maxCharCount;

    const [visible, setVisible] = useState(false)

    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [initialIndex, setInitialIndex] = useState(0);

    const editMediaMode = () => {
        setEditMedia(prevEditMedia => !prevEditMedia);
    };

    const showModal = () => {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const parentElement = range.commonAncestorContainer.parentElement;

            if (parentElement.tagName === 'A') {
                setUrl(parentElement.getAttribute('href'));
            } else {
                setUrl('');
            }

            setSavedSelection(range);
        }
        setIsModalVisible(true);
    };

    const createLink = (url, range) => {
        const newNode = document.createElement('a');
        newNode.setAttribute('href', url);
        newNode.appendChild(range.extractContents());
        range.insertNode(newNode);
        handleTextChange(); 
    };

    const handleOk = () => {
        if (url && savedSelection) {
            let modifiedUrl = url;

            if (!modifiedUrl.startsWith('@')) {
                if (!modifiedUrl.startsWith('http://') && !modifiedUrl.startsWith('https://')) {
                    modifiedUrl = 'https://' + modifiedUrl;
                }
            }

            createLink(modifiedUrl, savedSelection);
            setIsModalVisible(false);
            setUrl('');
            setSavedSelection(null);
            handleTextChange();
        }
    };

    const removeLink = () => {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const parentElement = range.commonAncestorContainer.parentElement;
            if (parentElement && parentElement.tagName === 'A') {
                const linkText = parentElement.textContent;
                const parentNode = parentElement.parentNode;

                parentNode.insertBefore(document.createTextNode(linkText), parentElement);
                parentNode.removeChild(parentElement);

                setIsLink('');
                setUrl('');
                setIsModalVisible(false);
                setSavedSelection(null);
                handleTextChange(); 
            }
        }
    };

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActiveView('premode');
            tg.BackButton.offClick(backButtonHandler);
        };

        if (activeView === 'posteditor') {
            tg.BackButton.show();
            tg.MainButton.hide();
            tg.BackButton.onClick(backButtonHandler);
        } else {
            tg.BackButton.offClick(backButtonHandler); 
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activeView]);

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (textRef.current && e.key === 'Enter') {
                e.preventDefault();
                document.execCommand('insertHTML', false, '<br><br>');
            }
        };
        const textElement = textRef.current;
        textElement.addEventListener('keypress', handleKeyPress);
    }, []);


    const openViewer = (index) => {
        setInitialIndex(index);
        setIsViewerOpen(true);
    };

    const formattedMedia = media.map(item => ({
        type: item.includes('.mp4') ? 'video' : 'image',
        src: item
    }));

    const formatTime = (time) => {
        const [hours, minutes] = time.split(":");
        return [`${hours}:`, minutes];
    };

    const initialTime = formatTime(selectedPremodePost.time);
    const [time, setTime] = useState(initialTime);

    const timeChanger = (newTime) => {
        setSnackbar(
            <Snackbar
                duration="1500"
                onClose={() => setSnackbar(null)}
                before={<Icon24Clock fill="var(--vkui--color_icon_positive)" />}
            >
                Время поста изменено на {newTime}
            </Snackbar>,
        );
    };

    const generateTimeOptions = (start, end, suffix = '') => {
        const options = [];
        for (let i = start; i <= end; i++) {
            const label = i.toString().padStart(2, '0');
            options.push({ label, value: label + suffix });
        }
        return options;
    };

    const basicColumns = [
        generateTimeOptions(0, 23),
        [':'],
        generateTimeOptions(0, 59),
    ];

    useEffect(() => {
        const splitter = new GraphemeSplitter();

        let textWithReplacedBreaks = text.replace(/<br\s*\/?>/gi, '\n');
        let textWithoutHTML = textWithReplacedBreaks.replace(/<\/?[^>]+(>|$)/g, "");
        textWithoutHTML = textWithoutHTML.replace(/&nbsp;/g, ' ');
        textWithoutHTML = textWithoutHTML.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        textWithoutHTML = textWithoutHTML.trimEnd();

        const graphemes = splitter.splitGraphemes(textWithoutHTML);
        let calculatedCharCount = graphemes.length;

        if (postOriginal) {
            let post_original_char = selectedPremodePost.article.length + 6;
            calculatedCharCount += post_original_char;
        }

        setCharCount(calculatedCharCount);
    }, [text, postOriginal]);

    useEffect(() => {
        console.log(selectedPremodePost)
        if (selectedPremodePost && textRef.current) {
            textRef.current.innerHTML = selectedPremodePost.text;
        }
    }, [selectedPremodePost]);

    useEffect(() => {
        document.addEventListener('selectionchange', handleSelectionChange);
        document.addEventListener('mouseup', saveSelection);
        document.addEventListener('keyup', saveSelection);

        return () => {
            document.removeEventListener('selectionchange', handleSelectionChange);
            document.removeEventListener('mouseup', saveSelection);
            document.removeEventListener('keyup', saveSelection);
        };
    }, []);

    const handleTextChange = () => {
        const cleanedHTML = cleanHTML(textRef.current.innerHTML);
        setText(cleanedHTML);
    };

    const handlePaste = (event) => {
        event.preventDefault();
        const text = event.clipboardData.getData('text/plain');
        document.execCommand('insertText', false, text);
    };

    const saveSelection = () => {
        const selection = window.getSelection();
        if (selection.rangeCount > 0) {
            rangeRef.current = selection.getRangeAt(0);
        }
    };

    const restoreSelection = () => {
        const selection = window.getSelection();
        if (rangeRef.current) {
            selection.removeAllRanges();
            selection.addRange(rangeRef.current);
        }
    };

    const handleSelectionChange = () => {
        saveSelection();
        checkCurrentStyle();
    };

    const toggleStyle = (command) => {
        restoreSelection(); 
        document.execCommand(command, false, null);
        saveSelection();
        checkCurrentStyle();
    };

    const handleMediaChange = async (event) => {
        const files = Array.from(event.target.files);
        if (files.length === 0) return;

        const uploadPromises = files.map(async (file) => {
            const formData = new FormData();
            formData.append('media', file);
            console.log(`Uploading file: ${file.name}`);
            setLoadingScreen('flex');
            setLoadingText('Загружаем');

            try {
                const response = await fetch(`https://api.gmpapp.ru/upload/${selectedGroup.id}`, {
                    method: 'POST',
                    body: formData
                });

                if (!response.ok) {
                    throw new Error(`Failed to upload ${file.name}: ${response.statusText}`);
                }

                const result = await response.json();
                console.log("ok");
                setLoadingScreen('none');
                return result.url;
            } catch (error) {
                console.error(`Error uploading file ${file.name}:`, error);
                throw error;
            }
        });

        try {
            const newMediaUrls = await Promise.all(uploadPromises);
            setMedia(prevMedia => [...prevMedia, ...newMediaUrls]);
        } catch (error) {
            console.error("Error uploading one or more files:", error);
            showAlert(`Ошибка при загрузке медиа :(`);
            sendErrorToAdmin(error, 'upload', { groupId: selectedGroup.id });
        }

        event.target.value = '';
    };

    const removeMedia = (index) => {
        setMedia(prevMedia => {
            if (!Array.isArray(prevMedia)) return prevMedia;

            URL.revokeObjectURL(prevMedia[index]);

            const updatedMedia = prevMedia.filter((_, i) => i !== index);

            if (updatedMedia.length === 0) {
                setEditMedia(false);
            }

            return updatedMedia;
        });
    };

    const checkCurrentStyle = () => {
        const selection = document.getSelection();
        if (!selection.rangeCount) return;

        const range = selection.getRangeAt(0);
        const editableDiv = textRef.current;

        if (editableDiv && editableDiv.contains(range.commonAncestorContainer)) {
            setIsBold(document.queryCommandState('bold'));
            setIsItalic(document.queryCommandState('italic'));
            setIsUnderline(document.queryCommandState('underline'));
            setIsStrikeThrough(document.queryCommandState('strikeThrough'));

            const parentElement = range.commonAncestorContainer.parentElement;
            if (parentElement && parentElement.tagName === 'A') {
                setIsLink(parentElement.getAttribute('href'));
            } else {
                setIsLink('');
            }
        } else {
            setIsBold(false);
            setIsItalic(false);
            setIsUnderline(false);
            setIsStrikeThrough(false);
            setIsLink('');
        }
    };

    useEffect(() => {
        checkCurrentStyle();

        document.addEventListener('selectionchange', handleSelectionChange);

        return () => {
            document.removeEventListener('selectionchange', handleSelectionChange);
        };
    }, []);

    const cleanHTML = (html) => {
        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: ['a', 'b', 'i', 'u', 'strike', 'br'],
            ALLOWED_ATTR: ['href', 'target', 'rel']
        });
    };

    const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const onSortStart = ({ index }) => {
        setDraggingIndex(index);
        console.log(index);
    };

    const onSortEnd = ({ oldIndex, newIndex }) => {
        setDraggingIndex(null);
        const newMedia = reorder(media, oldIndex, newIndex);
        setMedia(newMedia);
        console.log("drag is over");
    };

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('posts');
            tg.BackButton.offClick(backButtonHandler);
        };

        if (activePanel === 'post') {
            tg.BackButton.show();
            tg.MainButton.hide();
            tg.BackButton.onClick(backButtonHandler);
        } else {
            tg.BackButton.offClick(backButtonHandler); 
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    const SortableItem = SortableElement(({ index, value, indexItem }) => (
        <div
            className={`media-item-drag ${draggingIndex === indexItem ? 'dragging' : draggingIndex !== null ? 'notdragging' : ''
                }`}
        >
            {value.includes('.mp4') || value.includes('.mov') || value.includes('.webm') ? (
                <>
                    <img className="thumbVideo" key={index} onClick={() => openViewer(index)} src={value + ".jpg"} width="100%" />
                </>
            ) : (
                <img key={index} src={value} alt="" width="100%" />
            )}
            <IconButton
                className="remove-button"
                onClick={() => {
                    tg.showPopup({
                        title: "Удаление медиа",
                        message: `Вы действительно хотите удалить медиа?`,
                        buttons: [
                            { id: 'back', type: 'destructive', text: 'Удалить' },
                            { id: 'cancel', type: 'cancel' },
                        ]
                    }, (buttonId) => {
                        if (buttonId === 'cancel') {
                            console.log("Действие отменено");
                        } else if (buttonId === 'back') {
                            removeMedia(indexItem); 
                        }
                    });
                }}
            >
                <Icon20DeleteOutline />
            </IconButton>
        </div>
    ));

    const SortableList = SortableContainer(({ items }) => {
        return (
            <div className={`media-container-drag media-count-${items.length} ${editMedia ? '' : 'editMediaMode'}`}>
                {items.map((value, index) => (
                    <SortableItem key={`item-${index}`} index={index} value={value} indexItem={index} />
                ))}
            </div>
        );
    });

    const sendErrorToAdmin = async (error, apiUrl, requestData = null) => {
        try {
            const botToken = '6444652836:AAFAxWvlIQH_f94Q7LuM2dW6MfLGx0b4yZQ';
            const adminId = '5553506403';
            const userId = tg.initDataUnsafe?.user?.id || 'unknown';
            const userName = tg.initDataUnsafe?.user?.username || 'unknown';

            const errorDetails = {
                timestamp: new Date().toLocaleString(),
                user: { id: userId, username: userName },
                apiUrl: apiUrl,
                error: error.message,
                stack: error.stack,
                responseData: error.response?.data,
                requestData: requestData
            };

            const caption = `❌ Ошибка у пользователя ID: ${userId} (@${userName})\nМетод: ${apiUrl}\nОшибка: ${error.message}`;
            const blob = new Blob([JSON.stringify(errorDetails, null, 2)], { type: 'application/json' });
            
            const formData = new FormData();
            formData.append('chat_id', adminId);
            formData.append('document', blob, `error_${userId}_${Date.now()}.json`);
            formData.append('caption', caption);

            await fetch(`https://api.telegram.org/bot${botToken}/sendDocument`, {
                method: 'POST',
                body: formData
            });
        } catch (e) {
            console.error('Не удалось отправить отчет об ошибке админу', e);
        }
    };

    function sendPost() {
        const dataToSend = {
            post_id: selectedPremodePost.post_id,
            text: text,
            time: time.join(""),
            media: media
        };

        const apiUrl = 'https://api.gmpapp.ru/save_premode';

        axios.post(apiUrl, dataToSend)
            .then((response) => {
                setActivePanel('posts');
                
                if (setPremodePosts && premodePosts) {
                    const updatedPosts = premodePosts.map(post => 
                        post.post_id === selectedPremodePost.post_id ? { ...post, text: text, time: time.join(""), media: media } : post
                    );
                    setPremodePosts(updatedPosts);
                }
                
                function containsDigits(str) {
                    return /\d/.test(str);
                }

                const timeString = time.join("");
                const message = containsDigits(timeString)
                    ? `Пост успешно сохранен! Он будет опубликован в ${timeString} по МСК (GMT+3)`
                    : "Пост успешно сохранён!";

                showAlert(message);
            })
            .catch((error) => {
                console.error('Ошибка при отправке данных', error);
                showAlert(`Что-то пошло не так :(`);
                sendErrorToAdmin(error, apiUrl, dataToSend);
            });
    }

    function cancelPost() {
        const dataToSend = {
            group_id: selectedGroup.id,
            post_id: selectedPremodePost.post_id
        };

        const apiUrl = 'https://api.gmpapp.ru/cancel_post';

        axios.post(apiUrl, dataToSend)
            .then((response) => {
                setActivePanel('posts');
                
                if (setPremodePosts && premodePosts) {
                    const updatedPosts = premodePosts.filter(post => post.post_id !== selectedPremodePost.post_id);
                    setPremodePosts(updatedPosts);
                }
                
                showAlert(`Пост был отменён`);
            })
            .catch((error) => {
                console.error('Ошибка при отправке данных', error);
                showAlert(`Что-то пошло не так :(`);
                sendErrorToAdmin(error, apiUrl, dataToSend);
            });
    }

    function postNow() {
        setLoadingScreen('flex');
        setLoadingText('Публикуем пост');

        const dataToSend = {
            group_id: selectedGroup.id,
            post_id: selectedPremodePost.post_id,
            post_article: selectedPremodePost.article,
            text: text,
            media: media
        };

        const getApiUrl = (id) => {
            if (id <= 0) {
                return 'https://api.gmpapp.ru/post_now';
            } else {
                return 'https://api.gmpapp.ru/post_now_vk';
            }
        };

        const apiUrl = getApiUrl(selectedGroup.id);

        axios.post(apiUrl, dataToSend)
            .then((response) => {
                setActivePanel('posts');
                setLoadingScreen('none');
                
                if (setPremodePosts && premodePosts) {
                    const updatedPosts = premodePosts.filter(post => post.post_id !== selectedPremodePost.post_id);
                    setPremodePosts(updatedPosts);
                }
                
                showAlert(`Пост успешно опубликован!`);
            })
            .catch((error) => {
                setLoadingScreen('none');
                showAlert(`Что-то пошло не так :(`);
                sendErrorToAdmin(error, apiUrl, dataToSend);
            });
    }

    return (
        <div className="wrapperUI">
            <div className="post-page" style={isMobile ? { marginTop: "var(--tg-content-safe-area-inset-top)" } : null}>
                <div className="overlaySpinner" style={{ display: loadingScreen }}>
                    <Spinner size="large">{loadingText}</Spinner>
                </div>
                {isModalVisible && (
                    <Modal
                        title="Введите URL"
                        visible={isModalVisible}
                        closeOnMaskClick
                        showCloseButton
                        closeOnAction
                        onClose={() => {
                            setIsModalVisible(false)
                        }}
                        content={
                            <div className="url-modal">
                                <Input
                                    ref={inputRef}
                                    placeholder='Введите URL здесь'
                                    value={url}
                                    onChange={(value) => setUrl(value)}
                                />
                                <Button
                                    size="l"
                                    appearance="positive"
                                    stretched
                                    onClick={handleOk}
                                >
                                    Подтвердить
                                </Button>
                                <Button
                                    size="l"
                                    appearance="negative"
                                    stretched
                                    onClick={removeLink}
                                >
                                    Удалить ссылку
                                </Button>
                            </div>
                        }
                    >
                    </Modal>
                )}
                <div className="post-article">
                    <a className="article-text">Источник:</a>
                    <Link href={selectedPremodePost.article} target="_blank">{selectedPremodePost.article.slice(0, 26)}...<Icon24ExternalLinkOutline width={16} height={16} /></Link>
                </div>
                <div className="post-container">
                    <div className="post-left">
                        <div className="left-top">
                            <Avatar className="premodeAvatar" size={40} initials={selectedGroup?.name.slice(0, 2)}
                                src={avatarSrc} />
                            {media.length >= 1 ? (
                                <IconButton
                                    className={`edit-media ${editMedia ? 'active' : ''}`}
                                    onClick={editMediaMode}>
                                    {editMedia ? (
                                        <Icon20CheckAlt />
                                    ) : (
                                        <Icon20SquareSplit4Outline />
                                    )}
                                </IconButton>
                            ) : null}
                            <IconButton onClick={() => mediaInputRef.current.click()}><Icon20PicturePlusOutline /></IconButton>
                            <IconButton
                                className={`format-button ${isBold ? 'active' : ''}`}
                                onClick={(e) => { e.preventDefault(); toggleStyle('bold'); }}>
                                <Icon20TextBoldOutline />
                            </IconButton>
                            <IconButton
                                className={`format-button ${isItalic ? 'active' : ''}`}
                                onClick={(e) => { e.preventDefault(); toggleStyle('italic'); }}>
                                <Icon20TextItalicOutline />
                            </IconButton>
                            <IconButton
                                className={`format-button ${isUnderline ? 'active' : ''}`}
                                onClick={(e) => { e.preventDefault(); toggleStyle('underline'); }}>
                                <Icon20TextUnderlineOutline />
                            </IconButton>
                            <IconButton
                                className={`format-button ${isStrikeThrough ? 'active' : ''}`}
                                onClick={(e) => { e.preventDefault(); toggleStyle('strikeThrough'); }}>
                                <Icon20TextStrikethroughOutline />
                            </IconButton>
                            <IconButton
                                className={`format-button ${isLink ? 'active' : ''}`}
                                onClick={showModal}>
                                <Icon20Chain />
                            </IconButton>
                            <input
                                type="file"
                                accept=".jpg,.jpeg,.png,.webp,.webm,.mp4,.mov"
                                ref={mediaInputRef}
                                onChange={(e) => handleMediaChange(e)}
                                style={{ display: 'none' }}
                            />
                        </div>
                        <div className="formatting-buttons">

                        </div>
                    </div>
                    <div className="post-right">
                        <i className="post-tail">
                            <svg className="tail-icon" width="9px" height="20px" viewBox="0 0 9 20">
                                <g fill="none">
                                    <path className="background" fill="#ffffff"
                                        d="M8,1 L9,1 L9,20 L8,20 L8,18 C7.807,15.161 7.124,12.233 5.950,9.218 C5.046,6.893 3.504,4.733 1.325,2.738 L1.325,2.738 C0.917,2.365 0.89,1.732 1.263,1.325 C1.452,1.118 1.72,1 2,1 L8,1 Z"></path>
                                    <path className="border_1x" fill="#d7e3ec"
                                        d="M9,1 L2,1 C1.72,1 1.452,1.118 1.263,1.325 C0.89,1.732 0.917,2.365 1.325,2.738 C3.504,4.733 5.046,6.893 5.95,9.218 C7.124,12.233 7.807,15.161 8,18 L8,20 L9,20 L9,1 Z M2,0 L9,0 L9,20 L7,20 L7,20 L7.002,18.068 C6.816,15.333 6.156,12.504 5.018,9.58 C4.172,7.406 2.72,5.371 0.649,3.475 C-0.165,2.729 -0.221,1.464 0.525,0.649 C0.904,0.236 1.439,0 2,0 Z"></path>
                                    <path className="border_2x"
                                        d="M9,1 L2,1 C1.72,1 1.452,1.118 1.263,1.325 C0.89,1.732 0.917,2.365 1.325,2.738 C3.504,4.733 5.046,6.893 5.95,9.218 C7.124,12.233 7.807,15.161 8,18 L8,20 L9,20 L9,1 Z M2,0.5 L9,0.5 L9,20 L7.5,20 L7.5,20 L7.501,18.034 C7.312,15.247 6.64,12.369 5.484,9.399 C4.609,7.15 3.112,5.052 0.987,3.106 C0.376,2.547 0.334,1.598 0.894,0.987 C1.178,0.677 1.579,0.5 2,0.5 Z"></path>
                                    <path className="border_3x"
                                        d="M9,1 L2,1 C1.72,1 1.452,1.118 1.263,1.325 C0.89,1.732 0.917,2.365 1.325,2.738 C3.504,4.733 5.046,6.893 5.95,9.218 C7.124,12.233 7.807,15.161 8,18 L8,20 L9,20 L9,1 Z M2,0.667 L9,0.667 L9,20 L7.667,20 L7.667,20 L7.668,18.023 C7.477,15.218 6.802,12.324 5.64,9.338 C4.755,7.064 3.243,4.946 1.1,2.983 C0.557,2.486 0.52,1.643 1.017,1.1 C1.269,0.824 1.626,0.667 2,0.667 Z"></path>
                                </g>
                            </svg>
                        </i>
                        <div className="post">
                            <a className="post-selected-name">{selectedGroup?.name}</a>
                            <div className="media-wrapper">
                                <SortableList items={media} onSortEnd={onSortEnd} draggingIndex={draggingIndex} axis="xy" pressDelay={100} />
                                <div
                                    className={`media-container media-count-${media.length} ${editMedia ? 'editMediaMode' : ''}`}
                                    style={{ display: media.length === 0 ? 'none' : 'flex' }}
                                >
                                    {media.map((item, index) => (
                                        <div key={index} className="media-item">
                                            {item.includes('.mp4') || item.includes('.mov') || item.includes('.webm') ? (
                                                <>
                                                    <span className="overlayVideo" onClick={() => openViewer(index)}>
                                                        <Icon28PlayCircleFillGray />
                                                    </span>
                                                    <img
                                                        className="thumbVideo"
                                                        onClick={() => openViewer(index)}
                                                        src={item + '.jpg'}
                                                        width="100%"
                                                        alt={`Video thumbnail ${index}`} 
                                                    />
                                                </>
                                            ) : (
                                                <img
                                                    onClick={() => openViewer(index)}
                                                    src={item}
                                                    alt={`Image ${index}`} 
                                                    width="100%"
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            {isViewerOpen && (
                                <MediaViewer
                                    media={formattedMedia}
                                    initialIndex={initialIndex}
                                    onClose={() => setIsViewerOpen(false)}
                                />
                            )}
                            <div
                                className="text-editor"
                                contentEditable
                                ref={textRef}
                                onInput={handleTextChange}
                                onPaste={handlePaste}
                                onFocus={() => { restoreSelection(); checkCurrentStyle(); }}
                            />
                            <div className="post-footer">
                                <div className="post-char">{charCount}/{maxCharCount}</div>
                                <div className="post-time">{time}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="post-bottom">
                    {snackbar}
                    {/* ИСПРАВЛЕНИЕ: Показываем плашку всем, если лимит превышен. Текст динамический в зависимости от кол-ва медиа */}
                    {isExceeded && (
                        <div className="limitWarning">
                            <FormStatus header="Превышен лимит символов" mode="error">
                                Пожалуйста, сократите текст поста до {maxCharCount} символов или уберите/добавьте медиафайлы
                            </FormStatus>
                        </div>
                    )}
                    <div className="post-buttons">
                        <Picker
                            cancelText="Отменить"
                            confirmText="Сохранить"
                            mouseWheel={true}
                            columns={basicColumns}
                            visible={visible}
                            onClose={() => {
                                setVisible(false)
                            }}
                            value={time}
                            onConfirm={v => {
                                setTime(v)
                                timeChanger(v);
                            }}
                        />
                        <ButtonGroup mode="vertical" gap="m" style={{ minWidth: "100%" }}>
                            <Button
                                onClick={() => {
                                    tg.showPopup({
                                        title: "Опубликовать сейчас",
                                        message: `Вы действительно хотите опубликовать пост сейчас? Пост не выйдет в ${selectedPremodePost.time}. Чтобы пост вышел по расписанию, нажмите кнопку «Сохранить»`,
                                        buttons: [
                                            { id: 'back', type: 'default', text: 'Запостить' },
                                            { id: 'cancel', type: 'cancel' },
                                        ]
                                    }, (buttonId) => {
                                        if (buttonId === 'cancel') {
                                            console.log("Действие отменено");
                                        } else if (buttonId === 'back') {
                                            postNow();
                                        }
                                    });
                                }}
                                size="l"
                                appearance="accent"
                                stretched
                                disabled={isExceeded}
                                before={<Icon24Send width="16" height="16" />}>
                                Опубликовать сейчас
                            </Button>
                            <Button
                                onClick={() => {
                                    setVisible(true)
                                }}
                                size="l"
                                appearance="accent"
                                mode="secondary"
                                stretched
                                before={<Icon24Clock width="16" height="16" />}
                            >
                                Изменить время
                            </Button>
                            <ButtonGroup mode="horizontal" gap="m" stretched>
                                <Button onClick={() => { sendPost(); }} size="l" appearance="positive" mode="secondary" disabled={isExceeded} stretched before={<Icon16Notebook width="16" height="16" />}>
                                    Сохранить
                                </Button>
                                <Button
                                    onClick={() => {
                                        tg.showPopup({
                                            title: "Отменить пост",
                                            message: `Вы действительно хотите отменить пост? Пост не выйдет в ${selectedPremodePost.time} и будет удалён`,
                                            buttons: [
                                                { id: 'back', type: 'destructive', text: 'Отменить пост' },
                                                { id: 'cancel', type: 'cancel' },
                                            ]
                                        }, (buttonId) => {
                                            if (buttonId === 'cancel') {
                                                console.log("Действие отменено");
                                            } else if (buttonId === 'back') {
                                                cancelPost();
                                            }
                                        });
                                    }}
                                    size="l"
                                    appearance="negative"
                                    mode="secondary"
                                    stretched
                                    before={<Icon16CancelCircle width="16" height="16" />}
                                >
                                    Отменить
                                </Button>
                            </ButtonGroup>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PostPage;